import { IStockMovement } from "@/interfaces/sku-movement.interfaces";
import IProductVariation from "@/interfaces/variation.interface";
import { SkuTableMessages } from "@/messages/sku/sku-table.messages.";
import { FilterType, IFilter } from "@/types/filter.types";

export const SKU_TABLE_COLUMNS = (messages: SkuTableMessages) => {
  return [
    messages.imageColumn,
    messages.codeColumn,
    messages.nameColumn,
    messages.variationColumn,
    messages.stockolumn,
    messages.priceColumn,
    messages.statusColumn,
    messages.optionsColumn,
  ];
};

export const DIVISOR_FACTOR = 5000;

export const initialVariationFilterValues: IFilter<IProductVariation>[] = [
  {
    property: "description",
    value: "",
    filterType: FilterType.Contains,
  },
];

export const getInitialStockMovementFilterValues = (skuId: number): IFilter<IStockMovement>[] => [
  {
    property: "skuId",
    value: skuId,
    filterType: FilterType.Equals,
  },
];
